import axios from 'axios'
import router from '@/router/index'

// axios.defaults.baseURL = 'https://appapi.dh0762.com/';
axios.defaults.baseURL = 'https://appapi.hejiale.link/';

axios.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    
    if(token) {
        if (config.method === 'get') {
            config.params.token = token;
        } else if (config.method === 'post') {
            config.data.token = token;
        }
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    if (response.status === 200) {
        if (response.data.code === 40001) {
            localStorage.removeItem('token');
            router.push({
                name: 'login'
            })
        }
    }

    return response;
}, (error) => {
    return Promise.reject(error);
});


/**
 * 接口文档地址 https://yxwd.yxle.net/web/#/74?page_id=6077
 */

const api = {
    login: (parm = {}) => axios.post('/api/admin/v1/user/login', parm), // 登录
    uploadApp: (parm) => axios.post('/api/appfenfa/v1/setUploadApp', parm), // 上传app
    updateAppVersion: (parm = {}) => axios.post('/api/appfenfa/v1/setEditAppVersion', parm), // 更新app版本
    applicationList: (parm = {}) => axios.get('/api/appfenfa/v1/getAppFenFaList', { params: parm }) , // app列表
    getAppDetail: (parm = {}) => axios.get('/api/appfenfa/v1/getAppFenFaDetails', { params: parm }), // app详情
    hotUpdateAdd: (parm) => axios.post('/api/appfenfa/v1/setAppFenFaAppHotVersionAdd', parm), // app-添加热更新
    hotUpdateList: (parm = {}) => axios.get('/api/appfenfa/v1/getAppFenFaAppHotVersionList', { params: parm }), // app-热更新列表
    hotUpdateDel: (parm = {}) => axios.post('/api/appfenfa/v1/setAppFenFaAppHotVersionDelete', parm) ,// app-热更新删除
    hotUpdateSetStatus: (parm = {}) => axios.post('/api/appfenfa/v1/setAppFenFaAppHotVersionSetStatus', parm), // app-热更新修改状态
    downloadAppDetail: (parm = {}) => axios.get('/AppFenFa/v1/getAppFenVersionFaDetails', { params: parm }), // app-详情
    appDel: (parm = {}) => axios.post('/api/appfenfa/v1/setAppFenFaDelect', parm), // app-删除
    appVersionList: (parm = {}) => axios.get('/api/appfenfa/v1/getEditAppVersionList', { params: parm }), // app-获取版本列表
    appVersionStatus: (parm = {}) => axios.get('/api/appfenfa/v1/setEditAppVersionStatus', { params: parm }), // app-修改版本状态
}

export default api;